module.exports = __webpack_public_path__ + "img/equipment.859d81c5.png";